<div class="flex flex-col h-full">
    <div id="scroll-content-container" class="flex-auto basis-0">
        <mat-nav-list style="padding: 0" class="flex-auto">
            @for (tenant of tenants(); track tenant.id) {
                <a mat-list-item [routerLink]="tenant.routerLink">{{ tenant.name }}</a>
                <mat-divider />
            }
        </mat-nav-list>
    </div>
</div>
